import React from 'react'

import { ArrowIcon } from 'src/common/components/icons/ArrowIcon'
import {
  EnumTypographyVariants,
  Typography,
} from 'src/common/components/Typography/Typography'

import s from './StoryRecommendedTitle.module.scss'

export type StoryRecommendedTitleProps = {
  onNext: () => void
  onPrev: () => void
}

export const StoryRecommendedTitle: React.FC<StoryRecommendedTitleProps> = ({
  onNext,
  onPrev,
}) => {
  return (
    <div className={s.StoryRecommendedTitle}>
      <Typography
        className={s.StoryRecommendedTitle__title}
        variant={EnumTypographyVariants.H2}
      >
        Other reviews and cases
      </Typography>

      <div className={s.StoryRecommendedTitle__arrows}>
        <button
          onClick={onPrev}
          className={s.StoryRecommendedTitle__arrow_left}
        >
          <ArrowIcon />
        </button>

        <button
          onClick={onNext}
          className={s.StoryRecommendedTitle__arrow_right}
        >
          <ArrowIcon />
        </button>
      </div>
    </div>
  )
}
